import { useAuctionCarsAuctionPause } from './events/auctionCars/useAuctionCarsAuctionPause'
import { useAuctionCarsAuctionResume } from './events/auctionCars/useAuctionCarsAuctionResume'
import { useAuctionCarsAuctionTimeChange } from './events/auctionCars/useAuctionCarsAuctionTimeChange'
import { useAuctionCarsBidDeleted } from './events/auctionCars/useAuctionCarsBidDeleted'
import { useAuctionCarsBidOnAgent } from './events/auctionCars/useAuctionCarsBidOnAgent'
import { useAuctionCarsCarEnterHotbid } from './events/auctionCars/useAuctionCarsCarEnterHotbid'
import { useAuctionCarsCarFinished } from './events/auctionCars/useAuctionCarsCarFinished'
import { useAuctionCarsCarHotbidReset } from './events/auctionCars/useAuctionCarsCarHotbidReset'
import { useAuctionCarsCarInPrepare } from './events/auctionCars/useAuctionCarsCarInPrepare'
import { useAuctionCarsCarNotSold } from './events/auctionCars/useAuctionCarsCarNotSold'
import { useAuctionCarsCarReserved } from './events/auctionCars/useAuctionCarsCarReserved'
import { useAuctionCarsCarSold } from './events/auctionCars/useAuctionCarsCarSold'
import { useAuctionCarsItemPublish } from './events/auctionCars/useAuctionCarsItemPublish'
import { useAuctionCarsItemReserveRelease } from './events/auctionCars/useAuctionCarsItemReserveRelease'
import { useAuctionCarsItemWithdrawOrDelete } from './events/auctionCars/useAuctionCarsItemWithdrawOrDelete'
import { useAuctionCarsUserBid } from './events/auctionCars/useAuctionCarsUserBid'

export const AUCTION_CARS_SOCKET_CALLBACK = 'cars-list-update'

export function useAuctionCarsSocket() {
  const { userBid } = useAuctionCarsUserBid()
  const { auctionPause } = useAuctionCarsAuctionPause()
  const { auctionResume } = useAuctionCarsAuctionResume()
  const { itemPublish } = useAuctionCarsItemPublish()
  const { itemWithdrawOrDelete } = useAuctionCarsItemWithdrawOrDelete()
  const { bidDeleted } = useAuctionCarsBidDeleted()
  const { carEnterHotbid } = useAuctionCarsCarEnterHotbid()
  const { carInPrepare } = useAuctionCarsCarInPrepare()
  const { carNotSold } = useAuctionCarsCarNotSold()
  const { carSold } = useAuctionCarsCarSold()
  const { carReserved } = useAuctionCarsCarReserved()
  const { itemReserveRelease } = useAuctionCarsItemReserveRelease()
  const { carHotbidReset } = useAuctionCarsCarHotbidReset()
  const { auctionTimeChange } = useAuctionCarsAuctionTimeChange()
  const { carFinished } = useAuctionCarsCarFinished()
  const { bidOnAgent } = useAuctionCarsBidOnAgent()

  const init = () => {
    userBid()
    auctionPause()
    auctionResume()
    itemPublish()
    itemWithdrawOrDelete()
    bidDeleted()
    carEnterHotbid()
    carInPrepare()
    carNotSold()
    carSold()
    carReserved()
    itemReserveRelease()
    carHotbidReset()
    auctionTimeChange()
    carFinished()
    bidOnAgent()
  }

  return { init }
}
